import React from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import SnackbarContent from '../../components/Snackbar/SnackbarContent';
import EstudioForm from './EstudioForm';
import api from '../../components/Api/Api';

class EstudioPage extends React.Component {
  state = {
    pending: true,
    formData: {
      code: '',
      name: '',
      address: '',
      tel: ''
    }
  };

  constructor(props) {
    super(props);
    this.estudioID = props.match.params.id ? props.match.params.id : null;
    this.errorMsg = '';
  }

  componentDidMount() {
    if (this.estudioID) {
      this.queryEstudio();
    } else {
      this.setState({ pending: false });
    }
  }

  queryEstudio = () => {
    console.log(`fetching estudio with id ${this.estudioID}`);
    api('estudio/' + this.estudioID)
      .then(data => {
        console.log('estudio fetched');
        this.setState({ pending: false, formData: data.estudio });
      })
      .catch(error => {
        console.log(error);
        this.errorMsg = (
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <SnackbarContent message={'ojoooo'} close color='info' />
            </GridItem>
          </GridContainer>
        );
      });
  };

  render() {
    let formContent = '';
    if (this.state.pending) {
      formContent = <div>Esperando datos...</div>;
    } else {
      formContent = (
        <EstudioForm
          id={this.estudioID}
          code={this.state.formData.code}
          name={this.state.formData.name}
        />
      );
    }

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='info'>
                <h4 style={{ marginTop: '0', marginBottom: '0' }}>
                  Editar Estudio
                </h4>
                <p style={{ marginTop: '0', marginBottom: '0' }}>
                  Completar los datos del estudio
                </p>
              </CardHeader>
              <CardBody>
                {this.errorMsg}
                <GridContainer>{formContent}</GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default EstudioPage;
